<template>
  <div class="template-container disp-scroll">
    <div class="init-page">
      <div class="first-page">
        <div class="header">
          <h2 class="title">どの職種の人財を募集しますか？</h2>
        </div>
        <div class="template-content">
          <div class="item-container">
            <b-field class="job-detail" label="職種を選択">
              <div class="tab-content columns is-multiline">
                <b-tabs type="is-toggle" :animated="false" expanded
                style="height: auto; min-height: 420px; width: 95%; margin: 10px auto auto auto;">
                  <b-tab-item label="事務系">
                    <b-radio class="radio-item" v-model="content.job"
                      v-for="(v, i) in occupation.clerk" :key="i"
                      :native-value="v.name">
                      {{v.name}}
                    </b-radio>
                  </b-tab-item>
                  <b-tab-item label="営業系">
                    <b-radio class="radio-item" v-model="content.job"
                      v-for="(v, i) in occupation.business" :key="i"
                      :native-value="v.name">
                      {{v.name}}
                    </b-radio>
                  </b-tab-item>
                  <b-tab-item label="販売系">
                    <b-radio class="radio-item" v-model="content.job"
                      v-for="(v, i) in occupation.sales" :key="i"
                      :native-value="v.name">
                      {{v.name}}
                    </b-radio>
                  </b-tab-item>
                  <b-tab-item label="IT系">
                    <b-radio class="radio-item" v-model="content.job"
                      v-for="(v, i) in occupation.it" :key="i"
                      :native-value="v.name">
                      {{v.name}}
                    </b-radio>
                  </b-tab-item>
                  <b-tab-item label="技術系">
                    <b-radio class="radio-item" v-model="content.job"
                      v-for="(v, i) in occupation.technology" :key="i"
                      :native-value="v.name">
                      {{v.name}}
                    </b-radio>
                  </b-tab-item>
                  <b-tab-item label="専門系">
                    <b-radio class="radio-item" v-model="content.job"
                      v-for="(v, i) in occupation.profession" :key="i"
                      :native-value="v.name">
                      {{v.name}}
                    </b-radio>
                  </b-tab-item>
                </b-tabs>
              </div>
            </b-field>
            <div>
              <b-field class="job-detail" label="雇用形態">
                <b-select v-model="content.work_type">
                  <option v-for="(w, index) in workType" :value="w.name" :key="index">
                    {{w.jobname}}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div>
              <b-field class="job-detail" label="職種詳細を入力（職種と同一内容でも可）">
                <input v-model="content.sub_job" class="job-detail_input input" type="text" placeholder="フロントエンジニア">
              </b-field>
            </div>
          </div>
        </div>
        <div class="button-container">
          <div v-if="content.job === '' || content.sub_job === ''" class="button is-rounded" disabled>次へ</div>
          <div v-if="content.job !== '' && content.sub_job !== '' && occupationFlg === false" class="color-btn button is-rounded" @click="isOccupation">次へ</div>
          <div v-if="content.job === '' || content.sub_job === ''" class="button is-primary is-rounded" disabled>一時保存</div>
          <div v-if="content.job !== '' && content.sub_job !== '' && occupationFlg === false" class="color-btn button  is-primary is-rounded" @click="temporaryRegister">一時保存</div>
        </div>    
      </div>
      <div class="second-page" v-if="occupationFlg">
        <div class="header">
          <h2 class="title">募集したい「{{content.sub_job}}」について教えてください</h2>
        </div>
        <div class="template-content">
          <div class="item-container">
            <b-field class="job-detail" label="給与">
              <textarea v-model="content.salary" class="textarea disp-scroll" placeholder="月給25万円 〜"></textarea>
            </b-field>
            <b-field class="job-detail" label="勤務時間">
              <textarea v-model="content.work_time" class="textarea disp-scroll" placeholder="（例）9:00-18:00"></textarea>
            </b-field>
            <b-field class="job-detail" label="休日休暇">
              <textarea v-model="content.holiday" class="textarea disp-scroll" placeholder="（例）完全週休2日制"></textarea>
            </b-field>
            <b-field class="job-detail" label="福利厚生">
              <textarea v-model="content.welfare" class="textarea disp-scroll" placeholder=""></textarea>
            </b-field>
            <b-field class="job-detail" label="勤務先">
              <textarea v-model="content.location" class="textarea disp-scroll" placeholder="東京本社"></textarea>
            </b-field>
            <b-field class="job-detail" label="選考フロー">
              <textarea v-model="content.selection_flow" class="textarea disp-scroll" placeholder=""></textarea>
            </b-field>
            <b-field class="location-info-container" label="場所">
              <div class="location-info-wrapper">
                <div class="location-info">
                  <p class="location-info -name">郵便番号：</p><input v-model="content.postal_code" placeholder="郵便番号を入力" maxlength="8" class="input" id="zipcode"/>
                </div>
                <div class="location-info">
                  <p class="location-info -name">都道府県：</p><input v-model="content.region" placeholder="都道府県を入力" class="input"/>
                </div>
                <div class="location-info">
                  <p class="location-info -name">市町村区：</p><input v-model="content.locality" placeholder="市町村区を入力" class="input"/>
                </div>
                <div class="location-info">
                  <p class="location-info -name">番地等　：</p><input v-model="content.street" placeholder="それ以降の住所を入力" class="input"/>
                </div>
              </div>
            </b-field>
          </div>      
        </div>
        <div class="button-container">
          <div v-if="registerFlg === false" class="button is-rounded" disabled>登録</div>
          <div v-if="registerFlg === true" @click="register" class="color-btn button is-rounded">登録</div>
        </div>        
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import occupation from '@/assets/json/EmploymentPage/occupation.json'
import { Core as YubinBangoCore } from 'yubinbango-core'

export default {
  name: 'EmploymentTemplate',
  componentName: 'EmploymentTemplate',
  data () {
    return {
      occupation: occupation,
      occupationFlg: false,
      content: {
        work_type: '',
        job: '',
        sub_job: '',
        salary: '',
        holiday: '',
        welfare: '',
        work_time: '',
        location: '',
        postal_code: '',
        region: '',
        locality: '',
        street: '',
        google_map: '',
        selection_flow: ''
      },
      registerFlg: false,
      workType: [
        {
          name: 'FULL_TIME',
          jobname: '正社員'
        },
        {
          name: 'PART_TIME',
          jobname: 'アルバイト'
        },
        {
          name: 'CONTRACTOR',
          jobname: '契約社員'
        },
        {
          name: 'INTERN',
          jobname: 'インターン'
        },
        {
          name: 'OTHER',
          jobname: 'その他'
        }
      ],
      zip: null,
      pref_id: null,
      locality: null,
      street: null
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('employmentPage', ['rootContents', 'temporaryContents']),
  },
  watch: {
    'content.postal_code' (newVal) {
      console.log(newVal)
      if (newVal.length >= 7) {
        new YubinBangoCore(newVal, (addr) => {
          this.content.region = addr.region
          this.content.locality = addr.locality + addr.street
        })
      }
    },
    rootContents () {
      if (this.rootContents.length > 0) {
        this.content = {
          work_type: '',
          job: '',
          sub_job: '',
          salary: this.rootContents[0].salary,
          holiday: this.rootContents[0].holiday,
          welfare: this.rootContents[0].welfare,
          work_time: this.rootContents[0].work_time,
          location: this.rootContents[0].location,
          postal_code: this.rootContents[0].postal_code,
          region: this.rootContents[0].region,
          locality: this.rootContents[0].locality,
          street: this.rootContents[0].street,
          google_map: this.rootContents[0].google_map,
          selection_flow: this.rootContents[0].selection_flow
        }
      }
    },
    temporaryContents (){
      if (this.temporaryContents.length > 0) {
        this.content.id = this.temporaryContents[0].id
        this.content.work_type = this.temporaryContents[0].work_type
        this.content.job = this.temporaryContents[0].job
        this.content.sub_job = this.temporaryContents[0].sub_job
      }
    },
    content: {
      handler: function (content) {
        var array = [
          content.job,
          content.sub_job,
          content.salary,
          content.holiday,
          content.welfare,
          content.work_time,
          content.location,
          content.postal_code,
          content.region,
          content.locality,
          content.street,
          content.selection_flow,
        ]
        for (var v of array) {
          if (v === "") {
            this.registerFlg = false
            break
          } else {
            this.registerFlg = true
          }
        }
      },
      deep: true
    },
  },
  created () {
    this.$store.dispatch('employmentPage/getRootContent')
  },
  methods: {
    isOccupation () {
      this.occupationFlg = true
    },
    register () {
      this.content.company_id = this.user.companyID
      this.content.google_map = this.content.region + this.content.locality + this.content.street
      if (this.content.id == undefined) {
        this.$store.dispatch('employmentPage/postRootContent', {content: this.content, flg:false})
      } else {
        this.$store.dispatch('employmentPage/putRootContent', {content: this.content, flg:false})
      }
      this.content = {
        id: '',
        work_type: '',
        job: '',
        sub_job: '',
        salary: '',
        holiday: '',
        welfare: '',
        work_time: '',
        location: '',
        postal_code: '',
        region: '',
        locality: '',
        street: '',
        google_map: '',
        selection_flow: ''
      }
      this.$buefy.snackbar.open({
        message: '登録しました！',
        type: 'is-info',
        position: 'is-top'
      })
      this.$router.push('/dashboard/employment/list')
    },
    temporaryRegister () {   
      let temporary = {
        company_id: this.user.companyID,
        id: this.content.id,
        work_type: this.content.work_type,
        job: this.content.job,
        sub_job: this.content.sub_job,
        salary: '',
        holiday: '',
        welfare: '',
        work_time: '',
        location: '',
        postal_code: '',
        region: '',
        locality: '',
        street: '',
        google_map: '',
        selection_flow: ''
      }
      if (this.content.id == undefined) {
        this.$store.dispatch('employmentPage/postRootContent', {content: temporary, flg:true})
      } else {
        this.$store.dispatch('employmentPage/putRootContent', {content: temporary, flg:true})
      }
      this.$buefy.snackbar.open({ 
        message: '一時保存しました！',
        type: 'is-info',
        position: 'is-top',
       })
    }
  }
}
</script>

<style lang="scss" scoped>
.template-container {
  position: relative;
  margin: 0;
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
.init-page {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 90%;
  background: #fff;
  z-index: 10000;
  padding: 24px;
}
.button-container {
  margin: 40px 0 80px 0; 
}
.EmploymentTemplateOccupation {
  margin-bottom: 56px;
}
.header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 56px;
}
.tab-content {
  margin-top: 16px;
  height: auto;
  min-height: 440px;
}
.tab-item {
  margin: 24px 0 0 40px;
  text-align: left;
}
.radio-item {
  width: 33%;
  padding-bottom: 16px;
}
.job-detail {
  width: 80vw;
  margin: auto;
  margin-top: 32px;
  text-align: left;
}
.job-detail_input {
  width: 30vw;
}
.button-container {
  margin-top: 40px;
}
.color-btn {
  background: #ee2c98;
  color: #ffffff;
}
.item-container {
  margin: auto;
  width: 80vw;
}
.location-info-container {
  margin-top: 32px;
  text-align: left;
}
.location-info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 4px;
  & .-name {
    width: 124px;
    font-weight: bold;
  }
}
.b-radio.radio + .radio {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/EmploymentPage/EmploymentTemplate.vue